document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variantsJson = form.querySelector('[data-variants-json]');
  if (!variantsJson) return;

  var variants = JSON.parse(variantsJson.textContent);
  var optionInputs = form.querySelectorAll('[data-option-index]');
  var variantIdInput = form.querySelector('[name="id"]');
  var priceEl = document.querySelector('[data-product-price]');
  var buyButtons = document.querySelectorAll('[data-add-to-cart]');
  var stockNote = document.querySelector('[data-stock-note]');

  function currentSelection() {
    var selection = [];
    var groups = {};
    optionInputs.forEach(function (input) {
      if (input.checked) {
        groups[input.dataset.optionIndex] = input.value;
      }
    });
    var i = 0;
    while (groups.hasOwnProperty(String(i))) {
      selection.push(groups[String(i)]);
      i++;
    }
    return selection;
  }

  function findVariant(selection) {
    return variants.find(function (v) {
      return v.options.every(function (opt, idx) {
        return opt === selection[idx];
      });
    });
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function updateAvailability() {
    var selection = currentSelection();
    var matched = findVariant(selection);

    if (matched) {
      variantIdInput.value = matched.id;
      if (priceEl) priceEl.textContent = formatMoney(matched.price);

      buyButtons.forEach(function (btn) {
        btn.disabled = !matched.available;
        btn.textContent = matched.available ? btn.dataset.labelDefault : 'Sold out';
      });

      if (stockNote) {
        if (!matched.available) {
          stockNote.textContent = 'This option is currently sold out.';
          stockNote.className = 'stock-note out';
        } else if (matched.inventory_quantity !== null && matched.inventory_quantity <= 5 && matched.inventory_quantity > 0) {
          stockNote.textContent = 'Only ' + matched.inventory_quantity + ' left in stock.';
          stockNote.className = 'stock-note low';
        } else {
          stockNote.textContent = 'In stock, ready to ship.';
          stockNote.className = 'stock-note';
        }
      }
    }

    optionInputs.forEach(function (input) {
      var testSelection = selection.slice();
      testSelection[Number(input.dataset.optionIndex)] = input.value;
      var possible = variants.some(function (v) {
        return v.options.every(function (opt, idx) {
          return testSelection[idx] === undefined || opt === testSelection[idx];
        });
      });
      input.disabled = !possible;
    });
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', updateAvailability);
  });

  updateAvailability();

  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.cartQty;
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () {
        window.location.reload();
      });
    });
  });
});
